import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiCall } from '../utils/api';
import useUserPermissions from '../hooks/useUserPermissions';

function Runbook() {
  const navigate = useNavigate();
  const { canModify, isLoading } = useUserPermissions();
  const [tribe, setTribe] = useState('');
  const [solution, setSolution] = useState('');
  const [runbookTitle, setRunbookTitle] = useState('');
  const [modifiedBy, setModifiedBy] = useState('');
  
  const [tribes, setTribes] = useState([]);
  const [solutions, setSolutions] = useState([]);

  // Redirect users without modify permissions
  useEffect(() => {
    if (!isLoading && !canModify()) {
      alert('You do not have permission to create runbooks. Redirecting to runbook list.');
      navigate('/runbook_list');
      return;
    }
  }, [canModify, isLoading, navigate]);

  useEffect(() => {
    const fetchTribes = async () => {
      try {
        const data = await apiCall('/tribes');
        setTribes(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchTribes();
  }, []);

  useEffect(() => {
    if (tribe) {
      const fetchSolutions = async () => {
        try {
          const data = await apiCall(`/solutions?tribe=${tribe}`);
          if (Array.isArray(data)) {
            setSolutions(data);
          } else {
            setSolutions([]);
          }
        } catch (error) {
          console.error(error);
          setSolutions([]);
        }
      };
      fetchSolutions();
    } else {
      setSolutions([]);
    }
    setSolution('');
  }, [tribe]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const payload = {
      tribe,
      solution,
      runbookTitle,
      modifiedBy,
    };

    try {
        await apiCall('/runbooks', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });
        
        alert('Runbook created successfully!');
        navigate('/runbook_list');
    } catch(err) {
        console.error(err);
        alert(err.message || "Failed to create runbook");
    }
  };

  const handleCancel = () => {
    navigate('/runbook_list');
  };


  return (
    <div className="container mt-4">
      <h2>Create Runbook</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="tribe">Tribe:</label>
        <select id="tribe" name="tribe" value={tribe} onChange={(e) => setTribe(e.target.value)} required>
          <option value="">Select Tribe</option>
          {tribes.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>

        <label htmlFor="solution">Solution:</label>
        <select id="solution" name="solution" value={solution} onChange={(e) => setSolution(e.target.value)} required>
          <option value="">Select Solution</option>
          {solutions.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>

        <label htmlFor="runbook_title">Runbook Title:</label>
        <input
          type="text"
          id="runbook_title"
          name="runbook_title"
          value={runbookTitle}
          onChange={(e) => setRunbookTitle(e.target.value)}
          required
        />

        <label htmlFor="modified_by">Modified By:</label>
        <input
          type="text"
          id="modified_by"
          name="modified_by"
          value={modifiedBy}
          onChange={(e) => setModifiedBy(e.target.value)}
          required
        />

        <div className="button-container">
          <button type="submit">Submit</button>
          <button type="button" onClick={handleCancel}>Cancel</button>
        </div>

      </form>
    </div>
  );
}

export default Runbook;